export default "__VITE_ASSET__39eeb860__"